/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const websiteState = {
    byGUID: {},
    current_guid: undefined,
    current: {},
    navigation_tree: undefined,
    selectedNode: undefined,
    selectedNodeId: undefined,
    list: [],
};
